import { useEffect } from 'react';
import { DefaultErrorBoundary, SpacingMediumTopBottom } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, ScopeProvider } from '@mews/framework';
import { Button, IconName, Stack } from '@optimus-web/core';
import { PrintHiddenDiv } from '../../../../components/commander-ui';
import { ReservationsOverview, GuestsDialog, PrintableOverview, ResourcesDialog } from './components';
import { DispatchProps, OwnProps, StateProps } from './inject';

type SummaryProps = DispatchProps & OwnProps & StateProps;

const Summary = ({
    initializeSummary,
    scope,
    onPrint,
    editProfile,
    billingScreen,
    editInternal,
    reservations,
    selectedReservationServiceId,
}: SummaryProps) => {
    useEffect(() => {
        initializeSummary();
    }, [initializeSummary]);

    const handlePrint = () => {
        onPrint();
        window.print();
    };

    return (
        <DefaultErrorBoundary>
            <Stack spacing="200" vertical>
                <PrintHiddenDiv>
                    <Stack alignment="end">
                        <Button icon={IconName.Print} onClick={handlePrint} type="submit">
                            <LocalizedText textKey={TextKey.Print} />
                        </Button>
                    </Stack>
                </PrintHiddenDiv>
                <ScopeProvider value={scope}>
                    <PrintableOverview
                        serviceId={selectedReservationServiceId}
                        editProfile={editProfile}
                        billingScreen={billingScreen}
                        editInternals={editInternal}
                        scope={scope}
                    />
                    <PrintHiddenDiv>
                        <Stack spacing="200" vertical>
                            <ReservationsOverview reservations={reservations} scope={scope} />
                        </Stack>
                        <GuestsDialog
                            editProfile={editProfile}
                            billingScreen={billingScreen}
                            editInternals={editInternal}
                            serviceId={selectedReservationServiceId}
                        />
                        <ResourcesDialog serviceId={selectedReservationServiceId} />
                    </PrintHiddenDiv>
                </ScopeProvider>
                <SpacingMediumTopBottom />
            </Stack>
        </DefaultErrorBoundary>
    );
};
export default Summary;
